import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUser } from "../../utils/backend";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ViewUser = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState({});
  const { id } = useParams();

  const hasPermission = (permissionGroup, permissionName) => {
    let permissions;
    try {
      permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      permissions = [];
    }

    return permissions.some(
      (perm) =>
        perm.permission_group === permissionGroup &&
        perm.permission_name === permissionName
    );
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (id) => {
    setIsLoading(true);
    try {
      const response = await getUser({ id: id });
      setUser(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setUser({});
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate("/users");
  };

  const handlePurchaseClick = () => {
    navigate(`/users/purchase/${id}`);
  };

  return (
    <>
      {/* <h5 className='mb-3'>User Details</h5> */}
      {isLoading ? (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
              <div className="col-md-6 mb-3">
                <Skeleton height={20} width={150} />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Skeleton
                height={40}
                width={100}
                style={{ marginRight: "10px" }}
              />
              <Skeleton height={40} width={100} />
            </div>
          </div>
        </div>
      ) : (
        <div className="card border-light">
          <div className="card-body p-4">
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">ID</label>
                <p>
                  <b>{user.id || "N/A"}</b>
                </p>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Salutation</label>
                <p>
                  <b>{user.salutation || "N/A"}</b>
                </p>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Username</label>
                <p>
                  <b>{user.username || "N/A"}</b>
                </p>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Email</label>
                <p>
                  <b>{user.email || "N/A"}</b>
                </p>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Full Name</label>
                <p>
                  <b>{user.full_name || "N/A"}</b>
                </p>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Phone Number</label>
                <p>
                  <b>{user.phone_number || "N/A"}</b>
                </p>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">ID Type</label>
                <p>
                  <b>{user.id_type || "N/A"}</b>
                </p>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">ID Number</label>
                <p>
                  <b>{user.id_no || "N/A"}</b>
                </p>
              </div>

              {/* <div className="col-md-4 mb-3">
                                <label className="form-label">Vehicle Type</label>
                                <p><b>{user.vehicle_type || "N/A"}</b></p>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Vehicle Brand</label>
                                <p><b>{user.vehicle_brand || "N/A"}</b></p>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Vehicle Model</label>
                                <p><b>{user.vehicle_model || "N/A"}</b></p>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Vehicle Variants</label>
                                <p><b>{user.vehicle_variants || "N/A"}</b></p>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Vehicle CC</label>
                                <p><b>{user.vehicle_cc || "N/A"}</b></p>
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Vehicle Registration Date</label>
                                <p><b>{user.vehicle_registration_date ? new Date(user.vehicle_registration_date).toLocaleDateString('en-US') : "N/A"}</b></p>                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Ownership Type</label>
                                <p><b>{user.ownership_type || "N/A"}</b></p>
                            </div> */}

              {/* {user.ownership_type === 'Private' && (
                                <>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Vehicle Registration No.</label>
                                        <p><b>{user.vehicle_registration_number || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">ID Type</label>
                                        <p><b>{user.id_type || "N/A"}</b></p>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">ID Number</label>
                                        <p><b>{user.id_number || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Nationality</label>
                                        <p><b>{user.nationality || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Gender</label>
                                        <p><b>{user.gender || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Employment Status</label>
                                        <p><b>{user.employment_status || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Occupation</label>
                                        <p><b>{user.occupation || "N/A"}</b></p>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Date of Birth</label>
                                        <p><b>{user.date_of_birth ? user.date_of_birth.split('T')[0].split('-').reverse().join('/') : "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Address</label>
                                        <p><b>{user.address || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Postcode</label>
                                        <p><b>{user.postcode || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">City</label>
                                        <p><b>{user.city || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">State</label>
                                        <p><b>{user.state || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Marital Status</label>
                                        <p><b>{user.marital_status || "N/A"}</b></p>
                                    </div>
                                </>
                            )}
                            {user.ownership_type === 'Company' && (
                                <>


                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Contact Person ID Type</label>
                                        <p><b>{user.contact_person_id_type || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Contact Person ID Number</label>
                                        <p><b>{user.contact_person_id_number || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Contact Person Nationality</label>
                                        <p><b>{user.contact_person_nationality || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Business Name</label>
                                        <p><b>{user.business_name || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Business Registration Number</label>
                                        <p><b>{user.business_registration_number || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Business Contact Number</label>
                                        <p><b>{user.business_contact_number || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Address</label>
                                        <p><b>{user.address || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Postcode</label>
                                        <p><b>{user.postcode || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">City</label>
                                        <p><b>{user.city || "N/A"}</b></p>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">State</label>
                                        <p><b>{user.state || "N/A"}</b></p>
                                    </div>
                                </>
                            )} */}
            </div>

            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn ansa-button-secondary"
                onClick={handlePurchaseClick}
              >
                Purchase History
              </button>
              <div>
                <button
                  type="button"
                  className="btn me-3 ansa-button-secondary"
                  onClick={handleBackClick}
                >
                  Back
                </button>
                {hasPermission("User Management", "Edit") && (
                  <button
                    type="button"
                    className="btn ansa-button-primary"
                    onClick={() => navigate(`/users/details/${id}/edit`)}
                  >
                    Edit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewUser;
